import {
  EstimateItemModel,
  EstimateItemPricingModel,
} from '@app/+authenticated/+reports/shared/subscriptions/subscription.model';
import { _ } from '@ngx-translate/core';

export type EstimateItemType = 'plan' | 'overage' | 'integration' | 'compliance' | 'hr' | 'chat' | 'unknown';

export const ESTIMATE_ITEM_PRIORITY: EstimateItemType[] = [
  'plan',
  'overage',
  'integration',
  'compliance',
  'hr',
  'chat',
];

export const ESTIMATE_ITEM_NOTE_MAP: Record<'monthly' | 'yearly', Record<EstimateItemPricingModel, string>> = {
  monthly: {
    flat_fee: _('[price] x 1 month'),
    per_unit: _('[price] x [quantity] employees x 1 month'),
    tiered: _('[price] x [quantity] employees x 1 month'),
  },
  yearly: {
    flat_fee: _('[price] x 12 months'),
    per_unit: _('[price] x [quantity] employees x 12 months'),
    tiered: _('[price] x [quantity] employees x 12 months'),
  },
};

export const ESTIMATE_ITEM_DESCRIPTION_TYPE_MAP: Partial<Record<EstimateItemType, string>> = {
  integration: _('App Center Plus'),
  compliance: _('Compliance+'),
  hr: _('HR Pro'),
  chat: _('Chat'),
  overage: _('Additional employees (beyond included)'),
};

export function getEstimateItemType(item: EstimateItemModel): EstimateItemType {
  if (item.entity_type === 'plan_item_price') {
    return 'plan';
  }
  const id = item.entity_id.toLowerCase();
  if (id.includes('integration')) {
    return 'integration';
  }
  if (id.includes('compliance')) {
    return 'compliance';
  }
  if (id.includes('hr-pro')) {
    return 'hr';
  }
  if (id.includes('chat')) {
    return 'chat';
  }
  if (id.includes('seats') || id.includes('overage')) {
    return 'overage';
  }
  return 'unknown';
}
